import adjustColorBrightness from './adjustColorBrightness';
import { generateBoxShadow } from './generateBoxShadow';

/* 
if (appThemeType === '2') {
      root?.style.setProperty('--containers-background-color', '#F3F4F8');
    } else {
      root?.style.setProperty('--containers-background-color', '#ffffff');
    }
*/

export default function appThemeEngine(
  isAppThemeDark: boolean,
  merchantTheme: any,
  appThemeType: string
) {
  const root = document.documentElement;
  if (isAppThemeDark) {
    if (appThemeType === '2') {
      root?.style.setProperty('--containers-background-color', '#121212');
    } else {
      root?.style.setProperty('--containers-background-color', '#1f1f1f');
    }
    root?.style.setProperty('--main-background-color', '#121212');
    root?.style.setProperty('--help-setup-popup-background-color', '#121212');
    root?.style.setProperty('--main-border-color', '#424244');
    root?.style.setProperty('--header-color', '#1f1f1f');
    root?.style.setProperty('--main-text-color', '#e2e2e2');
    root?.style.setProperty('--sidebar-sublink-gray-text-color', '#e2e2e2');
    root?.style.setProperty('--sidebar-color', '#1f1f1f');
    root?.style.setProperty('--sidebar-hover-color', '#292929');
    root?.style.setProperty('--sidebar-hover-color-2', '#2929293d');
    root?.style.setProperty('--icon-color', '#e2e2e2');
    root?.style.setProperty('--sidebar-background-color', '#1f1f1f');
    root?.style.setProperty('--black-white-color', '#ffffff');

    // card colors for dark mode
    root?.style.setProperty('--card-green-background-color', '#134d2821');
    root?.style.setProperty('--card-blue-background-color', '#1e3a8a21');
    root?.style.setProperty('--card-purple-background-color', '#4c1d9521');
    root?.style.setProperty('--card-orange-background-color', '#7c2d1221');

    root?.style.setProperty('--containers-border-color', '#424244');
    root?.style.setProperty('--white-border-color', '#424244');
    root?.style.setProperty('--sidebar-sublink-hover-text-color', '#e2e2e2');
    root?.style.setProperty('--sidebar-sublink-hover-color', '#9999a9');
    root?.style.setProperty('--subPageLinkHolder-link-hover-color', '#424242');
    root?.style.setProperty(
      '--subPageLinkHolder-link-selected-color',
      '#424242'
    );
    root?.style.setProperty('--input-border-color', '#424244');
    root?.style.setProperty('--input-border-hover-color', '#52525b');
    root?.style.setProperty('--input-background-color', '#121212');
    root?.style.setProperty('--store-btn-color', '#424242');
    root?.style.setProperty('--gray-btn-light-background-color', '#4e4e50');
    root?.style.setProperty(
      '--gray-btn-light-hover-background-color',
      '#424242'
    );
    root?.style.setProperty('--gray-btn-light-text-color', '#e2e2e2');
    root?.style.setProperty('--subPageList-hover-color', '#4e4e50');
    root?.style.setProperty('--topbar-background-color', '#424242');
    root?.style.setProperty('--sub-text-color', '#e2e2e2');
    root?.style.setProperty('--sub-text-gray-1-color', '#e2e2e2');
    root?.style.setProperty('--login-background-color', '#121212');

    root?.style.setProperty('--background-highlight-color-1', '#2a2a2a');
    root?.style.setProperty('--background-highlight-color-2', '#2a2a2a');

    // message colors for dark mode
    root?.style.setProperty('--success-border-color', '#1e6f3d');
    root?.style.setProperty('--success-background-color', '#134d28');
    root?.style.setProperty('--success-text-color', '#79d78f');

    root?.style.setProperty('--warning-border-color', '#806100');
    root?.style.setProperty('--warning-background-color', '#4b3b00');
    root?.style.setProperty('--warning-text-color', '#ffca3a');
    root?.style.setProperty('--warning-darker-text-color', '#ffca3a');

    root?.style.setProperty('--danger-border-color', '#80231f');
    root?.style.setProperty('--danger-background-color', '#4d1210');
    root?.style.setProperty('--danger-text-color', '#ff6659');

    // SwitchShop dark mode variables
    root?.style.setProperty('--secondary-text-color', '#a0a0a0');
    root?.style.setProperty('--label-color', '#ffdd33');
    root?.style.setProperty('--search-results-color', '#ffdd33');
    root?.style.setProperty('--border-color', '#424244');
    root?.style.setProperty('--placeholder-color', '#a0a0a0');
    root?.style.setProperty('--focus-border-color', '#666666');
    root?.style.setProperty('--focus-shadow-color', 'rgba(102, 102, 102, 0.2)');
    root?.style.setProperty('--icon-color', '#a0a0a0');
    root?.style.setProperty('--hover-background-color', '#2a2a2a');
    root?.style.setProperty('--hover-text-color', '#e2e2e2');
    root?.style.setProperty('--no-results-bg', '#1a1a1a');
    root?.style.setProperty('--no-results-border', '#ffdd33');
    root?.style.setProperty('--no-results-text', '#ffdd33');
    root?.style.setProperty(
      '--current-shop-gradient',
      'linear-gradient(135deg, #ffdd33 0%, #ffb347 100%)'
    );
    root?.style.setProperty('--current-shop-text-color', '#2c2c2c');
    root?.style.setProperty(
      '--current-shop-shadow',
      '0 4px 12px rgba(255, 221, 51, 0.3)'
    );
    root?.style.setProperty(
      '--current-shop-overlay',
      'rgba(255, 255, 255, 0.15)'
    );
    root?.style.setProperty(
      '--current-shop-avatar-bg',
      'rgba(255, 255, 255, 0.25)'
    );
    root?.style.setProperty(
      '--current-shop-badge-bg',
      'rgba(255, 255, 255, 0.25)'
    );
    root?.style.setProperty('--shop-card-bg', '#1a1a1a');
    root?.style.setProperty('--shop-card-hover-bg', '#2a2a2a');
    root?.style.setProperty(
      '--shop-card-hover-shadow',
      '0 4px 12px rgba(255, 221, 51, 0.2)'
    );
    root?.style.setProperty('--shop-card-hover-border', '#ffdd33');
    root?.style.setProperty('--shop-card-active-bg', '#2a2a2a');
    root?.style.setProperty('--shop-card-active-border', '#ffdd33');
    root?.style.setProperty(
      '--shop-card-active-shadow',
      '0 4px 12px rgba(255, 221, 51, 0.3)'
    );
    root?.style.setProperty('--shop-card-active-text', '#ffdd33');
    root?.style.setProperty(
      '--shop-avatar-gradient',
      'linear-gradient(135deg, #ffdd33 0%, #ffb347 100%)'
    );
    root?.style.setProperty('--shop-avatar-text', '#2c2c2c');
    root?.style.setProperty('--shop-url-color', '#ffdd33');
    root?.style.setProperty('--shop-check-color', '#ffdd33');
    root?.style.setProperty('--pagination-btn-bg', '#1a1a1a');
    root?.style.setProperty('--pagination-btn-text', '#ffdd33');
    root?.style.setProperty('--pagination-btn-hover-bg', '#2a2a2a');
    root?.style.setProperty('--pagination-btn-hover-text', '#ffdd33');
    root?.style.setProperty('--pagination-btn-hover-border', '#ffdd33');
    root?.style.setProperty('--pagination-dot-bg', '#1a1a1a');
    root?.style.setProperty('--pagination-dot-text', '#ffdd33');
    root?.style.setProperty('--pagination-dot-hover-bg', '#2a2a2a');
    root?.style.setProperty('--pagination-dot-hover-border', '#ffdd33');
    root?.style.setProperty('--pagination-dot-active-bg', '#ffdd33');
    root?.style.setProperty('--pagination-dot-active-text', '#2c2c2c');
    root?.style.setProperty('--pagination-dot-active-border', '#ffdd33');
    root?.style.setProperty('--shop-loading-overlay', 'rgba(26, 26, 26, 0.9)');
    root?.style.setProperty('--loading-spinner-border', '#2a2a2a');
    root?.style.setProperty('--loading-spinner-color', '#ffdd33');
    root?.style.setProperty('--input-disabled-bg', '#2a2a2a');
    root?.style.setProperty('--input-disabled-text', '#666666');
  } else {
    root?.style.setProperty('--header-color', '#f2f2f2');
    root?.style.setProperty('--sidebar-color', '#fafafa');
    root?.style.setProperty('--sidebar-hover-color', '#f3f3f3');
    root?.style.setProperty('--sidebar-hover-color-2', '#f3f3f375');
    root?.style.setProperty('--icon-color', '#9999a9');

    if (appThemeType === '2') {
      root?.style.setProperty('--main-background-color', '#F3F4F8');
      root?.style.setProperty('--containers-background-color', '#F3F4F8');
    } else {
      root?.style.setProperty('--main-background-color', '#ffffff');
      root?.style.setProperty('--containers-background-color', '#ffffff');
    }

    root?.style.setProperty('--sidebar-background-color', '#ffffff');
    root?.style.setProperty('--help-setup-popup-background-color', '#ffffff');
    root?.style.setProperty('--containers-border-color', '#e4e4e7');
    root?.style.setProperty('--white-border-color', '#ebebeb');
    root?.style.setProperty('--sidebar-sublink-hover-text-color', '#18181b');
    root?.style.setProperty('--sidebar-sublink-hover-color', '#2e333d');
    root?.style.setProperty('--subPageLinkHolder-link-hover-color', '#f4f4f5');
    root?.style.setProperty('--subPageLinkHolder-link-selected-color', '#fff');
    root?.style.setProperty('--input-border-color', '#cecece');
    root?.style.setProperty('--input-border-hover-color', '#9999a9');
    root?.style.setProperty('--input-background-color', '#ffffff');
    root?.style.setProperty('--main-text-color', '#2e333d');
    root?.style.setProperty('--sidebar-sublink-gray-text-color', '#71717a');
    root?.style.setProperty('--store-btn-color', '#fff');
    root?.style.setProperty('--gray-btn-light-background-color', '#e2e2e2');
    root?.style.setProperty(
      '--gray-btn-light-hover-background-color',
      '#d7d7d7'
    );
    root?.style.setProperty('--black-white-color', '#000000');
    root?.style.setProperty('--gray-btn-light-text-color', '#9999a9');
    root?.style.setProperty('--subPageList-hover-color', '#f0f0f0');
    root?.style.setProperty('--topbar-background-color', '#fff');
    root?.style.setProperty('--sub-text-color', '#4c4c53');
    root?.style.setProperty('--sub-text-gray-1-color', '#475569');
    root?.style.setProperty('--login-background-color', '#f4f7fc');
    root?.style.setProperty('--main-border-color', '#e4e4e7');
    root?.style.setProperty('--background-highlight-color-1', '#f8fafc');
    root?.style.setProperty('--background-highlight-color-2', '#f1f5f9');

    // card colors for light mode
    root?.style.setProperty('--card-green-background-color', '#f0fdf4');
    root?.style.setProperty('--card-blue-background-color', '#eff6ff');
    root?.style.setProperty('--card-purple-background-color', '#faf5ff');
    root?.style.setProperty('--card-orange-background-color', '#fff7ed');

    // message colors for light mode
    root?.style.setProperty('--success-border-color', '#4aeb85');
    root?.style.setProperty('--success-background-color', '#f0fdf4');
    root?.style.setProperty('--success-text-color', '#25c660');
    root?.style.setProperty('--warning-border-color', '#ffcf7e');
    root?.style.setProperty('--warning-background-color', '#fffbeb');
    root?.style.setProperty('--warning-text-color', '#f8a61b');
    root?.style.setProperty('--warning-darker-text-color', '#b65f09');
    root?.style.setProperty('--danger-border-color', '#ff4433c7');
    root?.style.setProperty('--danger-background-color', '#fdf3f3');
    root?.style.setProperty('--danger-text-color', '#ff4433c7');

    // SwitchShop light mode variables
    root?.style.setProperty('--secondary-text-color', '#a2a5b9');
    root?.style.setProperty('--label-color', '#8b6f1a');
    root?.style.setProperty('--search-results-color', '#b8860b');
    root?.style.setProperty('--border-color', '#e1e5e9');
    root?.style.setProperty('--placeholder-color', '#6c757d');
    root?.style.setProperty('--focus-border-color', '#aaaaaa');
    root?.style.setProperty('--focus-shadow-color', 'rgba(161, 161, 161, 0.1)');
    root?.style.setProperty('--icon-color', '#6c757d');
    root?.style.setProperty('--hover-background-color', '#f8f9fa');
    root?.style.setProperty('--hover-text-color', '#495057');
    root?.style.setProperty('--no-results-bg', '#fffbf0');
    root?.style.setProperty('--no-results-border', '#ffdd33');
    root?.style.setProperty('--no-results-text', '#8b6f1a');
    root?.style.setProperty(
      '--current-shop-gradient',
      'linear-gradient(135deg, #ffdd33 0%, #ffb347 100%)'
    );
    root?.style.setProperty('--current-shop-text-color', '#2c2c2c');
    root?.style.setProperty(
      '--current-shop-shadow',
      '0 4px 12px rgba(255, 221, 51, 0.3)'
    );
    root?.style.setProperty(
      '--current-shop-overlay',
      'rgba(255, 255, 255, 0.15)'
    );
    root?.style.setProperty(
      '--current-shop-avatar-bg',
      'rgba(255, 255, 255, 0.25)'
    );
    root?.style.setProperty(
      '--current-shop-badge-bg',
      'rgba(255, 255, 255, 0.25)'
    );
    root?.style.setProperty('--shop-card-bg', '#fffbf0');
    root?.style.setProperty('--shop-card-hover-bg', '#fff8e1');
    root?.style.setProperty(
      '--shop-card-hover-shadow',
      '0 4px 12px rgba(255, 221, 51, 0.2)'
    );
    root?.style.setProperty('--shop-card-hover-border', '#ffdd33');
    root?.style.setProperty('--shop-card-active-bg', '#fff8e1');
    root?.style.setProperty('--shop-card-active-border', '#ffdd33');
    root?.style.setProperty(
      '--shop-card-active-shadow',
      '0 4px 12px rgba(255, 221, 51, 0.3)'
    );
    root?.style.setProperty('--shop-card-active-text', '#b8860b');
    root?.style.setProperty(
      '--shop-avatar-gradient',
      'linear-gradient(135deg, #ffdd33 0%, #ffb347 100%)'
    );
    root?.style.setProperty('--shop-avatar-text', '#2c2c2c');
    root?.style.setProperty('--shop-url-color', '#8b6f1a');
    root?.style.setProperty('--shop-check-color', '#b8860b');
    root?.style.setProperty('--pagination-btn-bg', '#fffbf0');
    root?.style.setProperty('--pagination-btn-text', '#8b6f1a');
    root?.style.setProperty('--pagination-btn-hover-bg', '#fff8e1');
    root?.style.setProperty('--pagination-btn-hover-text', '#b8860b');
    root?.style.setProperty('--pagination-btn-hover-border', '#ffdd33');
    root?.style.setProperty('--pagination-dot-bg', '#fffbf0');
    root?.style.setProperty('--pagination-dot-text', '#8b6f1a');
    root?.style.setProperty('--pagination-dot-hover-bg', '#fff8e1');
    root?.style.setProperty('--pagination-dot-hover-border', '#ffdd33');
    root?.style.setProperty('--pagination-dot-active-bg', '#ffdd33');
    root?.style.setProperty('--pagination-dot-active-text', '#2c2c2c');
    root?.style.setProperty('--pagination-dot-active-border', '#ffdd33');
    root?.style.setProperty(
      '--shop-loading-overlay',
      'rgba(200, 200, 200, 0.4)'
    );
    root?.style.setProperty('--loading-spinner-border', '#e0e0e0');
    root?.style.setProperty('--loading-spinner-color', '#666666');
    root?.style.setProperty('--input-disabled-bg', '#f5f5f5');
    root?.style.setProperty('--input-disabled-text', '#999999');
  }
  const themeColorConst = '#111111';
  const secondaryThemeColorConst = '#FFDD33';
  const textColorConst = isAppThemeDark ? '#e2e2e2' : '#2e333d';
  const btnTextColorConst = isAppThemeDark ? '#ffffff' : '#000000';
  const defaultFont = `'Geist Sans', sans-serif`;

  //white label
  root?.style.setProperty(
    '--main-brand-color',
    merchantTheme?.main_brand_color
      ? merchantTheme.main_brand_color
      : themeColorConst
  );

  root?.style.setProperty(
    '--main-brand-hover-color',
    merchantTheme?.main_brand_color
      ? merchantTheme.main_brand_color
      : adjustColorBrightness(themeColorConst, 50)
  );
  root?.style.setProperty(
    '--secondary-brand-color',
    merchantTheme?.secondary_brand_color
      ? merchantTheme.secondary_brand_color
      : secondaryThemeColorConst
  );

  root?.style.setProperty(
    '--secondary-brand-hover-color',
    merchantTheme?.secondary_brand_color
      ? merchantTheme.secondary_brand_color
      : adjustColorBrightness(secondaryThemeColorConst, 10)
  );

  root?.style.setProperty(
    '--main-btn-color',
    merchantTheme?.main_brand_color
      ? merchantTheme.main_brand_color
      : adjustColorBrightness(themeColorConst, -3)
  );

  root?.style.setProperty(
    '--main-btn-hover-color',
    merchantTheme?.main_brand_color
      ? merchantTheme.main_brand_color
      : adjustColorBrightness(themeColorConst, 15)
  );

  root?.style.setProperty(
    '--main-btn-text-color',
    merchantTheme?.main_btn_text_color && !isAppThemeDark
      ? merchantTheme.main_btn_text_color
      : btnTextColorConst
  );

  root?.style.setProperty('--main-text-color', textColorConst);
  // root?.style.setProperty(
  //   '--main-text-color',
  //   merchantTheme?.main_text_color && !isAppThemeDark
  //     ? merchantTheme.main_text_color
  //     : textColorConst
  // );

  root?.style.setProperty(
    '--main-font-primary',
    merchantTheme?.font_family &&
      merchantTheme?.font_family !== '' &&
      merchantTheme?.font_family !== 'null'
      ? merchantTheme.font_family
      : defaultFont
  );

  root?.style.setProperty(
    '--main-font-secondary',
    merchantTheme?.font_family_secondary &&
      merchantTheme?.font_family_secondary !== '' &&
      merchantTheme?.font_family_secondary !== 'null'
      ? merchantTheme.font_family_secondary
      : defaultFont
  );

  root?.style.setProperty(
    '--main-box-shadow',
    merchantTheme?.main_brand_color
      ? generateBoxShadow(merchantTheme?.main_brand_color)
      : generateBoxShadow(themeColorConst)
  );
}
